'use client';

import { VerticalSingleEndBanner } from '@northladder/design-system';
import { Text, useTranslations } from '@northladder/i18n';

import { DisplayDeviceName } from '../DisplayDeviceName';

interface IAssessmentCompleteSuccessProps {
  evaluationId: string;
}

/**
 * -----------------------------------------------------------------------------
 * This is rendered when the user has successfully completed the assessment.
 */
export function AssessmentCompleteSuccess({
  evaluationId,
}: IAssessmentCompleteSuccessProps) {
  const t = useTranslations('FunctionalAssessmentComplete');

  return (
    <div className="flex flex-col items-center justify-center gap-10 pt-8">
      <div className="flex flex-col items-center justify-center gap-2 px-4">
        <p
          className="
            text-body-text text-center text-base font-medium leading-tight
          "
        >
          {t('introText')}
        </p>
        <h1 className="text-body-text text-center text-2xl font-bold leading-8">
          {t('title')}
        </h1>
        <div
          className="
            text-primary-600 dark:text-primary-300 text-center text-sm font-bold leading-4
          "
        >
          {t('subTitle')}
          <DisplayDeviceName evaluationId={evaluationId} />
        </div>
      </div>

      {/* TODO: Animate presence with Framer motion */}
      <VerticalSingleEndBanner
        className="my-12"
        subtitle={t('badgeSubtitle')}
        title={t('badgeTitle')}
      />

      <div
        className="
          flex max-w-xs flex-col items-center justify-center gap-2 pb-10
          text-center text-sm font-normal leading-5
        "
      >
        <p className="flex flex-col text-gray-600 dark:text-gray-400">
          {t('instructionLine1')}
          {t('instructionLine2')}
        </p>
        <hr className="my-2 w-full border-gray-400/10" />
        <Text
          className="text-xs text-gray-600/50 dark:text-gray-400"
          text={t('notice')}
        />
      </div>
    </div>
  );
}
